import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { NgIf } from '@angular/common';
import { IconComponent } from './icon.component';
import { TranslatePipe } from '../pipes/translate.pipe';

/** Section title with optional sub-line and a right-aligned action link. */
@Component({
  selector: 'app-section-head',
  standalone: true,
  imports: [NgIf, IconComponent, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<div style="display:flex;align-items:flex-end;justify-content:space-between;padding:0 16px;margin-bottom:12px">
      <div>
        <h3 style="margin:0;font-family:var(--brand-display);font-size:21px;font-weight:700;
            letter-spacing:-0.02em;color:var(--fr-text)">{{ title | t }}</h3>
        <p *ngIf="sub" style="margin:2px 0 0;font-size:13px;color:var(--fr-text-2)">{{ sub | t }}</p>
      </div>
      <button *ngIf="action" (click)="act.emit()"
        style="background:none;border:none;cursor:pointer;color:var(--brand-deep);font-size:13.5px;
               font-weight:700;display:flex;align-items:center;gap:2px;padding:0">
        {{ action | t }} <app-icon name="solar:alt-arrow-right-linear" [size]="15"></app-icon>
      </button>
    </div>`,
})
export class SectionHeadComponent {
  @Input() title = '';
  @Input() sub?: string;
  @Input() action?: string;
  @Output() act = new EventEmitter<void>();
}
